import { buttonVariants, dateVariants, dayVariants } from './variants';

import type { VariantProps } from 'class-variance-authority';
import type { ComponentProps } from 'react';

type Props = ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    day: string;
    fullDate: string;
    dateClassName?: string;
    dayClassName?: string;
  };

export const SelectDayButton = ({
  active,
  className,
  dateClassName,
  day,
  dayClassName,
  fullDate,
  highlight,
  past,
  size,
  variant,
  ...props
}: Props) => (
  <button className={buttonVariants({ active, className, highlight, past, size, variant })} type="button" {...props}>
    <span className={dayVariants({ active, className: dayClassName, past, variant })}>{day}</span>
    <span className={dateVariants({ className: dateClassName, highlight })}>{fullDate}</span>
  </button>
);
